export default "__VITE_ASSET__CMXcP3yn__"